import {handleTryPremiumContentClick} from './module_common';

import { signInGoToCheckoutAndBack } from './module_auth_helper';

import {
    configPlayerCard,
    attachTheUpdateCardPlayerBtn,
} from './module_player-card';


function attachTheupdateCantAccessDetail(){
    const cards = document.querySelectorAll(".tu-not-premium")
    cards.forEach((card) => {
        card.addEventListener('click', onCardClickForCantRead)
    })
}

const onCardClickForCantRead = function(e){
    e.stopPropagation()
    e.preventDefault()
    if (!UIDg){
        signInGoToCheckoutAndBack()
    }else{
        handleTryPremiumContentClick(window.location.href)
    }
}

export const configTuCard = function(){
    attachTheupdateCantAccessDetail()
    configPlayerCard()
    attachTheUpdateCardPlayerBtn()
}